'use strict';

var _ = require('lodash');
var PricingBarChartDataProviderService = function PricingBarChartDataProviderService(pricingSummaryCommonsDataService) {
  var brushFilterStrategies = {
    'summary-pos': function summaryPos(poses, d) {
      return _.includes(poses, d.pos);
    }
  };
  function retrieveData() {
    return pricingSummaryCommonsDataService.getSummaryData();
  }
  function filter(snapshotDate, runNumber, brushFilters, data) {
    var filteredData = _.filter(data, {
      optimizationDate: snapshotDate,
      runNumber: runNumber
    });
    _.forOwn(brushFilters, function (filter, name) {
      filteredData = _.filter(filteredData, _.partial(brushFilterStrategies[name], filter));
    });
    return filteredData;
  }
  function aggregate(dataSetName, data) {
    var metric = dataSetName === 'pos' ? 'pos' : 'market';
    return _.transform(data, function (accumulators, el) {
      var key = el[metric];
      accumulators[key] = accumulators[key] || {
        markets: [],
        poses: [],
        label: key,
        numberOfEffectedServices: 0,
        numberOfExcludedServices: 0,
        numberOfExtendedServices: 0,
        totalFareChange: 0
      };
      accumulators[key].markets.push(el.market);
      accumulators[key].poses.push(el.pos);
      calculateFieldValue(accumulators[key], el, 'numberOfEffectedServices');
      calculateFieldValue(accumulators[key], el, 'numberOfExcludedServices');
      calculateFieldValue(accumulators[key], el, 'numberOfExtendedServices');
      calculateFieldValue(accumulators[key], el, 'totalFareChange');
      return accumulators;
    }, {});
  }
  function calculateFieldValue(accumulator, el, fieldName) {
    accumulator[fieldName] = accumulator[fieldName] + (el[fieldName] || 0);
  }
  function prepareChart(metric, data) {
    var chartData = _.values(data);
    return _.chain(chartData).map(function (obj) {
      return {
        market: _.uniq(obj.markets),
        pos: _.uniq(obj.poses),
        label: obj.label,
        fareChange: calculateBarValue(obj, metric),
        numberOfEffectedServices: obj.numberOfEffectedServices,
        numberOfExcludedServices: obj.numberOfExcludedServices,
        numberOfExtendedServices: obj.numberOfExtendedServices,
        selected: true,
        circles: [{
          css: 'm3-circle',
          value: obj.numberOfEffectedServices
        }, {
          css: 'm4-circle',
          value: obj.numberOfExcludedServices
        }]
      };
    }).orderBy(['numberOfEffectedServices'], ['desc']).value();
  }
  function calculateBarValue(obj, metric) {
    return metric.metric === 'avgFareChange' ? _.round(obj.totalFareChange / obj.numberOfEffectedServices, 2) || 0 : obj.totalFareChange;
  }
  function getData(dataSetName, metric, snapshotDate, runNumber, brushFilters) {
    return retrieveData().then(_.partial(filter, snapshotDate, runNumber, brushFilters)).then(_.partial(aggregate, dataSetName)).then(_.partial(prepareChart, metric));
  }
  return {
    getData: getData
  };
};
PricingBarChartDataProviderService.$inject = ['PricingSummaryCommonsDataService'];
module.exports = PricingBarChartDataProviderService;